/**
 * KisiPanelGiris — geçici kişi panelinin giriş ekranı (backlog #646; backend #644). SMS'teki bağlantıdaki anahtar + geçici şifre.
 *
 * Sayfa açılırken SUNUCUYA HİÇBİR ŞEY sorulmaz: bağlantının geçerli olup olmadığı ancak şifre gönderilince ve HEP AYNI cevapla öğrenilir (yanlış bağlantı, yanlış şifre,
 * süresi dolmuş davet ve iptal edilmiş davet ayırt edilmez). Kilit (çok yanlış deneme) ayrı söylenir, çünkü kişinin yapabileceği bir şey vardır (şirketinden yeni davet istemek).
 * Bağlantıda anahtar yoksa (sayfa doğrudan açıldıysa) anahtar elle girilebilir. Backend ikinci bir kontrol isterse (kimlik / pasaport no'nun son haneleri) alan açılır.
 */
import React, { useState } from 'react';
import { Alert, Button, Form, Input, Label, Spinner } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { girisYap } from '../../../services/kisiPanelService';

const KisiPanelGiris = ({ token, onGirildi, bilgi }) => {
  const { t } = useTranslation('kisiPanel');
  const [elleToken, setElleToken] = useState('');
  const [sifre, setSifre] = useState('');
  const [kimlikSon, setKimlikSon] = useState('');
  const [ikinciKontrol, setIkinciKontrol] = useState(false);
  const [gonderiyor, setGonderiyor] = useState(false);
  const [hata, setHata] = useState(null);   // 'gecersiz' | 'kilitli' | 'baglanti'
  const anahtar = token || elleToken.trim();

  async function gonder(e) {
    e.preventDefault();
    if (!anahtar || !sifre) return;
    setGonderiyor(true);
    setHata(null);
    try {
      await girisYap({ token: anahtar, sifre, kimlikSon });
      setSifre('');
      onGirildi();
    } catch (err) {
      setSifre('');
      if (err.ikinciKontrol) { setIkinciKontrol(true); setHata('ikinciKontrol'); }
      else if (err.network) setHata('baglanti');
      else if (err.status === 423 || err.status === 429) setHata('kilitli');
      else setHata('gecersiz');   // 401, 403, 404, süresi dolmuş, iptal: hepsi aynı
    } finally {
      setGonderiyor(false);
    }
  }

  return (
    <div data-testid="kisi-panel-giris">
      <div className="text-center mt-2">
        <h5 className="text-body">{t('giris.baslik')}</h5>
        <p className="text-muted">{t('giris.aciklama')}</p>
      </div>
      {bilgi && <Alert color="info" fade={false} className="py-2" data-testid="giris-bilgi">{t(`giris.${bilgi}`)}</Alert>}
      {hata && <Alert color={hata === 'baglanti' ? 'warning' : 'danger'} fade={false} className="py-2" data-testid="giris-hata">{t(`giris.hata.${hata}`)}</Alert>}
      <Form onSubmit={gonder}>
        {!token && (
          <div className="mb-3">
            <Label htmlFor="kp-giris-token">{t('giris.token')}</Label>
            <Input id="kp-giris-token" autoComplete="off" autoCapitalize="off" spellCheck={false} maxLength={256} value={elleToken} onChange={(e) => setElleToken(e.target.value)} />
            <div className="form-text">{t('giris.tokenIpucu')}</div>
          </div>
        )}
        <div className="mb-3">
          <Label htmlFor="kp-giris-sifre">{t('giris.sifre')}</Label>
          <Input id="kp-giris-sifre" type="password" autoComplete="one-time-code" inputMode="text" autoFocus bsSize="lg" maxLength={64}
            value={sifre} onChange={(e) => setSifre(e.target.value)} invalid={hata === 'gecersiz'} />
          <div className="form-text">{t('giris.sifreIpucu')}</div>
        </div>
        {ikinciKontrol && (
          <div className="mb-3">
            <Label htmlFor="kp-giris-kimlik">{t('giris.kimlikSon')}</Label>
            <Input id="kp-giris-kimlik" inputMode="numeric" autoComplete="off" maxLength={8} value={kimlikSon} onChange={(e) => setKimlikSon(e.target.value)} />
            <div className="form-text">{t('giris.kimlikSonIpucu')}</div>
          </div>
        )}
        <Button color="primary" size="lg" className="w-100" type="submit" id="kp-giris-gonder" disabled={gonderiyor || !anahtar || !sifre}>
          {gonderiyor ? <Spinner size="sm" /> : t('giris.gonder')}
        </Button>
      </Form>
    </div>
  );
};

export default KisiPanelGiris;
